import { SizeFormComponent } from './size-form/size-form.component';
import { SizeListComponent } from './size-list/size-list.component';
import { ColorFormComponent } from './color-form/color-form.component';
import { CategoryFormComponent } from './category-form/category-form.component';
import { NgModule } from '@angular/core';
import { SubcategoryListComponent } from './subcategory-list/subcategory-list.component';
import { CategoryListComponent } from './category-list/category-list.component';
import { SubcategoryFormComponent } from './subcategory-form/subcategory-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SettingsRoutingModule } from './settings-routing.module';
import { ColorListComponent } from './color-list/color-list.component';


@NgModule({
    declarations: [
        CategoryListComponent,
        CategoryFormComponent,
        SubcategoryListComponent,
        SubcategoryFormComponent,
        ColorFormComponent,
        ColorListComponent,
        SizeListComponent,
        SizeFormComponent
    ],
    imports: [
      SharedModule,
      SettingsRoutingModule
    ]
  })
  export class SettingsModule { }